import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FinancialChartService} from '../../_services/financial-chart.service';
import {FinancialChartAccountOptions, FinancialChartAccountOptionsItem} from '../../_models/financial-account.model';
import {Subscription} from 'rxjs';
import {LineItemRequest} from '../../_models/financial-inventory.model';
import {FinancialInventoryService} from '../../_services/financial-inventory.service';

@Component({
  selector: 'acabim-admin-add-inventory',
  templateUrl: './add-inventory.component.html',
  styleUrls: ['./add-inventory.component.scss']
})
export class AddInventoryComponent implements OnInit, OnDestroy {

  @Input() existingLineItem: any | null = null;
  @Output() closeModal = new EventEmitter<boolean>();

  addItemForm: FormGroup | null = null;
  addItemRequest: LineItemRequest | null = null;
  accounts: FinancialChartAccountOptions[] = [];
  accountSub: Subscription = new Subscription();
  inventorySub: Subscription = new Subscription();
  taxMethods: FinancialChartAccountOptionsItem[] =[
    {label: 'None', value: 'None'},
    {label: 'Exclusive', value: 'Exclusive'},
    {label: 'Inclusive', value: 'Inclusive'},
  ];
  taxAmounts: FinancialChartAccountOptionsItem[] =[
    {label: 'Zero', value: 0},
    {label: '+15%', value: 0.15},
    {label: '-15%', value: -0.15}
  ];

  constructor(
      private readonly financialChartService: FinancialChartService,
      private readonly financialInventoryService: FinancialInventoryService
  ) {
  }

  ngOnInit(): void {
    this.accountSub = this.financialChartService.getChartOfAccountsAsOptions(false, true).subscribe(accounts => {
      this.initForm();
      this.accounts = accounts;
      this.setFrom();

    });
  }

  ngOnDestroy(): void {
    this.accountSub.unsubscribe();
  }

  initForm(): void {
    this.addItemForm = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null),
      code: new FormControl(null),
      cost: new FormControl(null),
      price: new FormControl(null),
      account: new FormControl(null),
      taxMethod: new FormControl(null),
      taxValue: new FormControl(null)
    });
  }

  setFrom(): void {
    if (this.existingLineItem && this.addItemForm) {
      this.inventorySub = this.financialInventoryService.getInventoryItem(this.existingLineItem.id).subscribe(data => {
        console.dir(data);
        if (data) {
          this.addItemForm?.get('id')?.setValue(data.id);
          this.addItemForm?.get('name')?.patchValue(data.name);
          this.addItemForm?.get('code')?.setValue(data.code);
          this.addItemForm?.get('cost')?.setValue(data.default_cost);
          this.addItemForm?.get('price')?.setValue(data.default_price);
          this.addItemForm?.get('account')?.setValue(data.default_account.id);
          this.addItemForm?.get('taxMethod')?.setValue(data.default_tax_method);
          this.addItemForm?.get('taxValue')?.setValue(data.default_tax_value);
        }

      });
    }
  }

  onComplete(): void {
    if (this.addItemForm) {
      const id = this.addItemForm?.get('id')?.value ?? null;
      this.addItemRequest =  {
        code: this.addItemForm?.get('code')?.value ?? '',
        name: this.addItemForm?.get('name')?.value ?? '',
        default_cost: this.addItemForm?.get('cost')?.value ?? 0,
        default_price: this.addItemForm?.get('price')?.value ?? 0,
        default_account_id: this.addItemForm?.get('account')?.value ?? 0,
        default_tax_method: this.addItemForm?.get('taxMethod')?.value ?? 0,
        default_tax_value: this.addItemForm?.get('taxValue')?.value ?? 0,
      };
      console.dir(this.addItemRequest);
      if (id) {
        this.inventorySub = this.financialInventoryService.updateInventoryItem(id, this.addItemRequest).subscribe(data => {
          console.dir(data);
          this.closeModal.emit(true);
        });
      } else {
        this.inventorySub = this.financialInventoryService.addInventory(this.addItemRequest).subscribe(data => {
          console.dir(data);
          this.closeModal.emit(true);
        });
      }
    }

  }

  onCancel(): void {
    this.closeModal.emit(true);
  }

}
